




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Request from "@/modules/request/Request";
import Tag from "@/components/miscellaneous/Tag.vue";

@Component({ components: { Tag } })
export default class Status extends Vue {
    @Prop( { default: null }) public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.status",
            "request.children.status",
        ];
    }
}
